<template>
<div class="chapter">
<div class="inner_page">
<div class="cover"><img alt="" height="100%" src="9781847675705_cover_epub.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847675705_cover.vue?18fd3546